import {World} from "@core/world";
import {Area} from "@core/area";
import {Kingdom} from "@core/kingdom";

export class WorldsKingdomsLands {
  worlds: World[] = [];
  areas: Area[] = [];

  worldMap: Map<string, World> = new Map<string, World>();
  kingdomMap: Map<string, Kingdom> = new Map<string, Kingdom>();
  areaMap: Map<string, Area> = new Map<string, Area>();
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/park/worldsKingdomsLands.ts